export const mainMenuConfigKey = Symbol()
